import { getSDKConfig } from '../../shares/lib/getSDKConfig';

export const isPathMatching = (pagesToShow: string[]): boolean => {
  if (!pagesToShow?.length) {
    console.warn(
      'miniGame - Invalid pagesToShow: It must be a non-empty string array.',
    );
    return false;
  }

  let currentPath = window.location.pathname.toLowerCase();

  currentPath = currentPath.replace(/^\/+/, '');

  const normalizePathToRegex = (path: string) => {
    const normalizedPath = path.replace(/^\/+/, '').toLowerCase();

    return new RegExp(
      '^' +
        normalizedPath.replace(/:\w+/g, '([^/]+)').replace(/\*/g, '.*') +
        '$',
    );
  };

  const regexPatterns = pagesToShow.map(normalizePathToRegex);
  const isMatch = regexPatterns.some((regex) => regex.test(currentPath));

  return isMatch;
};

export const validateMiniGameConfig = (): boolean => {
  const swipeSDKConfig = getSDKConfig();
  if (!swipeSDKConfig?.enableMiniGames) {
    return false;
  }

  const { domElement, pagesToShow } = swipeSDKConfig.miniGames || {};

  if (typeof domElement !== 'string' || domElement.trim() === '') {
    console.warn(
      'miniGame - Invalid domElement: It must be a non-empty string.',
    );
    return false;
  }

  if (!isPathMatching(pagesToShow || [])) {
    return false;
  }

  return true;
};
